import axios from 'axios';
import { config } from '../../Configs';

export const OwnershipRequestAPI = async (
  id,
  data,
  captchaToken,
  authToken = null
) => {
  const configObj = {
    params: { 'g-recaptcha-response': captchaToken },
    headers: { Authorization: authToken }
  };

  try {
    const response = await axios.post(
      `${config.api.url}/ownership/${id}`,
      data,
      configObj
    );
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const HasOwnershipRequestAPI = async (
  id,
  captchaToken,
  authToken = null
) => {
  const configObj = {
    params: { 'g-recaptcha-response': captchaToken },
    headers: { Authorization: authToken }
  };

  try {
    const response = await axios.get(
      `${config.api.url}/ownership/${id}`,
      configObj
    );
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};
